import React from 'react';
import { Alert, Card, Col, Row } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { FaSave } from 'react-icons/fa';
import { FaPlus } from 'react-icons/fa';
import { FaDownload } from 'react-icons/fa6';
import { RiArrowLeftDoubleLine } from 'react-icons/ri';
import { customStyles } from '../../../../components/Table/style';
import { MdError } from 'react-icons/md';



const VisitsDymanicTable = ({ columns, data, title, addRow, saveTemplate, searchTemplate, loadLastVisit, errorMessage = '', isHideIcons = false }) => {
	return (
		<Row className='my-3'>
			<Card.Title>{title}</Card.Title>
			{errorMessage.length > 0 && (
				<Alert variant='danger'>
					<p>
						<MdError size={18} className='mr-2' />
						{Array.isArray(errorMessage) ? errorMessage.join(' | ') : errorMessage}
					</p>
				</Alert>
			)}
			<Col>
				<Row className="d-flex justify-content-between align-items-center">
					<Col md={1} className="d-flex justify-content-between align-items-center">
						<div className="btn btn-circle d-flex justify-content-center align-items-center" onClick={() => saveTemplate(title)}>
							<FaSave size={18} className="mb-2" />
						</div>
						{!isHideIcons && (
							<>
								<div className="btn btn-circle d-flex justify-content-center align-items-center" onClick={() => searchTemplate(title)}>
									<FaDownload size={18} className="mb-2" />
								</div>
								<div className="btn btn-circle d-flex justify-content-center align-items-center" onClick={() => loadLastVisit(title)}>
									<RiArrowLeftDoubleLine size={18} className="mb-2" />
								</div>
							</>
						)}
						<div className="btn btn-circle d-flex justify-content-center align-items-center" onClick={() => addRow(title)}>
							<FaPlus size={18} className="mb-2" />
						</div>
					</Col>
				</Row>
				<DataTable
					columns={columns}
					data={data}
					customStyles={customStyles}
				/>
			</Col>
		</Row>
	);
};

export default VisitsDymanicTable;
